import Form from "./Form";
import Cards from "./Cards";

export default function RecipePage() {
	return (
		<div>
			<h1>Recipe</h1>
			<hr/>
			<Form />
			<Cards />
		</div>
	);
}
